import "./Shop.module.css";
import Navigation from "@/reusable_sections/Header";
import Shop from "./sections/Shop";
import ShopContent from "./sections/ShopContent";
import Footer from "@/reusable_sections/Footer";
export default function ShopPage() {
  return <div>
      <Navigation />
      <Shop />
      <ShopContent />
      <Footer />
    </div>;
}